import React, { useEffect, useState } from "react";
import Table from "../../../../Components/Tables/Table";
import { getDeskTopBottomSection } from "../Service/InboundServices";
import { LeftColumnConfig, LeftSectionProps, LeftLineItem } from "../Model/Mobile.type";


const LeftSection: React.FC<LeftSectionProps> = ({desktopBottomSection, handleRowClick,asnValidateResponse }) => {
  const [data, setData] = useState<LeftLineItem[]>();
  useEffect(() => {
          if(desktopBottomSection){
            getDeskTopBottomSection(desktopBottomSection).then((response)=>{
              setData(response.data.results);
            });
             
        }
  }, [desktopBottomSection,asnValidateResponse])
  const columns = desktopBottomSection?.call_back_url_params?.columns?.map(({ title, data }: LeftColumnConfig) => {
    if (title === "Item Code" || title === "Item Name") {
      return {
        name: "Items",
        selector: (row: any) => (
          <>
            <div className="fw-bold">{row.name}</div>
            <div>{row.code}</div>
          </>
        ),
      };
    }
    return {
      name: title,
      selector: (row: any) => {
        const cleanData = data.replace('inbound_shipment_line.', '');
        const keys = cleanData.split('.');
        return keys.reduce((acc, key) => (acc ? acc[key] : undefined), row);
      },
    };
  }).filter((col: any, index: number, self: any[]) => 
    index === self.findIndex((c: any) => c.name === col.name)
  ) || [];


  return data ?(
    <div className="white-body d-flex justify-content-center align-items-center mt-2">
      <div className="justify-content-between inboundReceiveDataTable w-100 p-1 table-padding-5">
        <Table  columns={columns} data={data} handleRowClick={handleRowClick} CheckboxStatus={false} />
      </div>
    </div>
  ):(<></>);
};

export default LeftSection;
